
import markerSDK from '@marker.io/browser'

export default {
  async created() {
    await Promise.all([
      this.$store.dispatch('profile/fetchProfile'),
      this.$store.dispatch('profile/fetchPastoralAbbrevMapping'),
      this.$store.dispatch('profile/fetchMinistryStatus'),
      this.$store.dispatch('lookups/fetchIfNotYet'),
      this.$store.dispatch('lookups/fetchCgMapping'),
      this.$store.dispatch('lookups/fetchZoneCgMapping'),
      this.$store.dispatch('profile/fetchBibleStudiesStatus'),
      this.$store.dispatch('cms/fetchCmsForm', { formName: this.$route.params.formName }),
    ])

    // Conditionally fetch data based on form prepopulation requirements
    const currentForm = this.$store.state.cms.form[this.$route.params.formName]
    if (currentForm && currentForm.prepopulation) {
      const fetchPromises = []

      // Fetch pastoral abbreviation mapping if form requires it
      if (currentForm.prepopulation.pastoral_status) {
        fetchPromises.push(this.$store.dispatch('profile/fetchPastoralAbbrevMapping'))
      }

      // Fetch bible studies status if form requires it
      if (currentForm.prepopulation.bible_studies_status) {
        fetchPromises.push(this.$store.dispatch('profile/fetchBibleStudiesStatus'))
      }

      // Fetch ministry status if form requires it
      if (currentForm.prepopulation.ministry_status) {
        fetchPromises.push(this.$store.dispatch('profile/fetchMinistryStatus'))
      }

      if (fetchPromises.length > 0) {
        await Promise.all(fetchPromises)
      }
    }

    if (process.env.NODE_ENV === 'staging') {
      const widget = await markerSDK.loadWidget({
        destination: process.env.MARKERIO_DESTINATION, // <- Your unique destination ID
      })
      widget.setReporter({ email: this.email, fullName: this.name })
    }
  },
}
